<template>
  <div class="home-view">
      <chillNavbar class="home" current_visit="" betreiber="REWE Nord" />
      <div class="filter-box">
            <label for="searchMarket">{{trans('available_markets')}}</label>
            <input
                id="searchMarket"
                class="filter-input"
                type="text"
                :placeholder="trans('search_markets')"
                :value="filterMarketText"
                @input="e => filterMarketText = e.target.value"
            >
            <img v-if="!gps" class="gps-icon" :src="require('../assets/gps-disabled.png')" alt="gps" @click="activateGps()" />
            <img v-else class="gps-icon" :src="require('../assets/gps-active.png')" alt="gps" @click="activateGps()" />
      </div>
      <div class="list-of-markets">
            <div v-if="user_home_client == ''">
                <span>{{trans('please_wait_to_be_approved')}}</span>
                <span>{{trans('after_approval_you_might_need_to_refresh_the_page')}}</span>
            </div>
            <div v-else-if="blockedLocation" >
                <span>{{trans("no_position_access")}}</span>
                <span>{{ trans("please_search_for_markets") }}</span>
            </div>
            <div v-else-if="!gps && !filterMarketText" class="no-gps-no-search-text">
                <span>{{ trans("please_search_for_markets") }}</span>
            </div>
            <div v-else-if="filterMarketText" class="market-row" v-for="m in marketSearch(markets)" v-bind:key="m.id" @click="toMarket(m.id)" >
                <span class="market-text" >{{ trans(m.owner) }}, {{ trans(m.market_id_rewe) }}</span>
                <span class="market-text">{{ trans(m.city) }}, {{ trans(m.street) }}</span>
            </div>
            <div v-else-if="gps" class="gps-true">
                <div v-if="loadingGps" class="loading-box"><loadingDotsDark /></div>
                <div v-if="blockedLocation"><p>{{trans("activate_position_to_search_with_your_location")}}</p></div>

                <div v-for="m in useGps()" :key="m.id"  @click="toMarket(m.id)" >
                    <div v-if="typeof m === 'string'"><p>{{ m }}</p></div>
                    <div v-else class="market-row">
                        <span class="market-text" >{{ trans(m.owner) }}, {{ trans(m.market_id_rewe) }}</span>
                        <span class="market-text">{{ trans(m.city) }}, {{ trans(m.street) }}</span>
                    </div>
                </div>
            </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data(){
    return {
        filterMarketText: '',
        lat: false,
        lng: false,
        gps: false,
        loadingGps: false,
        blockedLocation: false,

        coordinates: {},
        noLocation: true,
    }
  },
  beforeRouteEnter(to, from, next){
    if(to.name == "home" && from.name == "login"){
        setTimeout( function(){next()}, 1000)
    }else{
      next()
    }
  },
  beforeRouteLeave(to, form , next){
    this.clearMarketData();
    next()
  },
  // computed(){
  //   getUser(){
  //     return {role: localStorage.getitem("user_role"), client: localStorage.getitem("user_client")}
  //   }
  // },
  watch: {
    user_home_client(){
        this.startMarketListener()
    },
    filterMarketText() {
        this.gps = false
        this.loadingGps = false
        this.blockedLocation = false
    }
  },
  methods:{
    closeby(m_lat,m_lng){
        return this.getDistance(this.coordinates.lat, this.coordinates.lng, m_lat, m_lng) < 1
    },
    getDistance(lat1, lon1, lat2, lon2) {
        var R = 6371; // km
        var dLat = this.toRad(lat2-lat1);
        var dLon = this.toRad(lon2-lon1);
        lat1 = this.toRad(lat1);
        lat2 = this.toRad(lat2);

        var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        var d = R * c;
        return d;
    },
    toRad(Value) {
        return Value * Math.PI / 180;
    },
    marketSearch(marketList) {
        let re = []

        let s = this.filterMarketText.toLowerCase()
        let wordArray = s.split(' ')
        wordArray.forEach((word, index) => {
            let temp = []
            marketList.forEach(m => {
                if(index === 0) {
                    if((m.city.toLowerCase().includes(word) || m.street.toLowerCase().includes(word) || m.market_id_rewe.toLowerCase().includes(word) || m.owner.toLowerCase().includes(word))) {
                        temp.push(m)
                    }
                }
                else {
                    const found = re.some(o => o.id === m.id);
                    if (found) {
                        if(word !== '' && (m.city.toLowerCase().includes(word) || m.street.toLowerCase().includes(word) || m.market_id_rewe.toLowerCase().includes(word) || m.owner.toLowerCase().includes(word))) {
                            temp.push(m)
                        }
                    }
                }
            })
            if(word !== '') re = temp
        })
        return re;
    },
    toMarket(id){
        if(id) this.$router.push({ path: `/market/${id}` });
    },
     useGps() {
        if(Object.keys(this.coordinates).length > 0) {
            let r = []
            for(let m of this.markets) {
                if(this.coordinates.lat && this.coordinates.lng && this.closeby(m.geolocation.lat, m.geolocation.lng)) {
                    r.push(m)
                }
            }
            if(r.length === 0) { r = [this.trans('no_markets_near_your_location')] }
            this.loadingGps = false
            return r
        }
        else return null
    },
    activateGps() {
        this.gps = true
        this.loadingGps = true
        this.blockedLocation = false
        this.filterMarketText = ''
        
        this.$getLocation().then(coordinates => {
            this.coordinates = coordinates
        }).catch (() => {
            this.testError = true
            this.blockedLocation = true
            this.loadingGps = false
        })
    },
  },
  mounted()
  {
    this.startMarketListener()
    this.startSpecialCaseUserListener(this.getUser().uid)
  }
}
</script>

<style scoped lang="scss">
    .home-view {
        margin: 150px auto 0px auto;
        width: 86vw;
        height: calc(100vh - 150px);
        max-width: 900px;
        .filter-box {
            display: flex;
            flex-direction: column;
            margin: 0px auto;
            position: relative;
            .filter-input {
                background-color: #fff;
                max-width: 100%;
                padding-left: 4px;
                font-size: 14px;
                font-weight: 300;
                border: none;
                border-bottom: solid transparent 2px;
                height: 28px;
                &:focus {
                    outline: none;
                    border: none;
                    border-bottom: solid #51D07D 2px;
                }
            }
        }
        .list-of-markets {
            max-height: calc(100vh - 250px);
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            margin: 0px auto;
            margin-top: 30px;
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            &::-webkit-scrollbar { 
                display: none;  /* Safari and Chrome */
            }
            .market-row {
                margin: 8px 0px;
                height: 56px;
                min-height: 56px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                border-left: solid #1B608C 5px;
                background-color: #FFF;
                &:hover {
                    cursor: pointer;
                }
                .market-text {
                    margin: auto 8px;
                }
            }
        }
    }
    label {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-weight: 400;
    }
    span {
        font-size: 14px;
        font-weight: 300;
    }
    input[type=text] {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }
    .loading-box {
        height: 40px;
    }
    .gps-icon {
        position: absolute;
        bottom: 7px;
        right: 10px;
        width: 20px;
        height: 20px;
        &:hover {
            cursor: pointer;
        }
    }
</style>